<template>
  <div id="detailspage" class="">
    <div id="userinfo" class="space-y-3">
      <!-- name, FH name, DOB, Address, Mobno, Marital Status -->
      <div id="name" class="inline-block space-y-2">
        <p class="text-xl text-blue-400 font-medium">
          Name of the Applicant (in Block Letters) :
        </p>
        <h3 class="text-md uppercase font-serif font-bold">
          {{ $store.state.Candidate.application.userinfo.Candidate_name }}
        </h3>
      </div>
      <div id="fhname">
        <p class="text-xl text-blue-400 font-medium">Father / Husband Name :</p>
        <h3 class="text-md uppercase font-bold font-serif">
          {{ $store.state.Candidate.application.userinfo.Father_Husband_Name }}
        </h3>
      </div>
      <div id="dob">
        <p class="text-xl text-blue-400 font-medium">Date of Birth :</p>
        <h3 class="text-md uppercase font-bold font-serif">
          {{ $store.state.Candidate.application.userinfo.DOB }}
        </h3>
      </div>
      <div class="flex flex-wrap">
        <div class="lg:w-1/2">
          <div id="address" class="border-2 shadow-lg">
            <p class="text-xl text-blue-400 font-medium border-b-2 ml-3">
              Address :
            </p>
            <div class="m-3">
              <p>
                {{
                  $store.state.Candidate.application.userinfo.Present_Address1
                }},
              </p>
              <p>
                {{
                  $store.state.Candidate.application.userinfo.Present_Address2
                }},
              </p>
              <p>
                {{
                  $store.state.Candidate.application.userinfo.Present_Address3
                }},
              </p>
              <p>
                City :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Present_City
                }}</span>
              </p>
              <p>
                State :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Present_State
                }}</span>
              </p>
              <p>
                PIN :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Present_pincode
                }}</span>
              </p>
              <p>
                Phone / Mobile No.
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Candidate_mobileno
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="lg:w-1/2">
          <div id="address" class="border-2 shadow-lg">
            <p class="text-xl text-blue-400 font-medium border-b-2 ml-3">
              Address :
            </p>
            <div class="m-3">
              <p>
                {{
                  $store.state.Candidate.application.userinfo
                    .Permanent_Address1
                }},
              </p>
              <p>
                {{
                  $store.state.Candidate.application.userinfo
                    .Permanent_Address2
                }},
              </p>
              <p>
                {{
                  $store.state.Candidate.application.userinfo
                    .Permanent_Address3
                }},
              </p>
              <p>
                City :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Permanent_City
                }}</span>
              </p>
              <p>
                State :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Permanent_State
                }}</span>
              </p>
              <p>
                PIN :
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Permanent_pincode
                }}</span>
              </p>
              <p>
                Phone / Mobile No.
                <span class="uppercase font-bold">{{
                  $store.state.Candidate.application.userinfo.Candidate_mobileno
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="mstatus">
        <p class="text-xl text-blue-400 font-medium">Marital Status :</p>
        <h3 class="text-md font-bold uppercase font-serif">
          <span
            v-if="$store.state.Candidate.application.userinfo.Marital_status"
          >
            Married
          </span>
          <span v-else>Unmarried</span>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
